import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
@Injectable({
  providedIn: 'root'
})
export class BillingServiceService extends AppService<any> {

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "stripe";
  }

  public singlePayment(data:any): Observable<any> {
    let temp =   this.appmod 
    this.appmod = "custom/singlePayment";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }
  
  public updatePayment(data:any): Observable<any> {
    let temp =   this.appmod 
    this.appmod = "custom/updatePayment";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }
  public getStripeKeys(): Observable<any> {
    let temp =   this.appmod 
    this.appmod = "custom/getStripeKeys";
    let result = super.getService();
    this.appmod = temp;
    return result;
  }
  public getStripeData(): Observable<any> {
    let temp =   this.appmod 
    this.appmod = "custom/getStripeData";
    let result = super.getService();
    this.appmod = temp;
    return result;
  }
  
  public addStripeKeys(data:any): Observable<any> {
    let temp =   this.appmod 
    this.appmod = "custom/addStripeKeys";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }

  public updateStripeKeys(data:any,id:any): Observable<any> {
    let temp =   this.appmod 
    this.appmod = "custom/updateStripeKeys";
    let result = super.updateService(data,id);
    this.appmod = temp;
    return result;
  }
  public setbydefault(data:any,id:any): Observable<any> {
    let temp =   this.appmod 
    this.appmod = "custom/setbydefault";
    let result = super.saveService(data,id);
    this.appmod = temp;
    return result;
  }

  public deleteStripeData(data:any): Observable<any> {
    let temp =   this.appmod 
    this.appmod = "custom/deleteStripeData";
    let result = super.deleteService(data);
    this.appmod = temp;
    return result;
  }
  public cardsDetail(data: any): Observable<any> {
    let temp = this.appmod
    this.appmod = "custom/cardsDetail";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }
  public addBalance(data: any): Observable<any> {
    let temp = this.appmod
    this.appmod = "custom/addbalance";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }
  public saveDetails(data:any){
    let temp =   this.appmod 
    this.appmod = "custom/saveDetails";
    let result = super.saveService(data);
    this.appmod = temp;
    return result;
  }
  public checkouPay(data:any): Observable<any>{
    let temp = this.appmod
    this.appmod = "custom/checkoutPay";
    let result = super.saveService(data);
    this.appmod =temp;
    return result;
  }
}
